import { ARBITRUM, BSC, AVALANCHE_FUJI } from "config/chains";
import invert from "lodash/invert";

export const NETWORK_QUERY_PARAM = "network";
export const VERSION_QUERY_PARAM = "v";

export const NETWORK_SLUGS_ID_MAP = {
  arbitrum: ARBITRUM,
  bsc: BSC,
  bsc_fuji: AVALANCHE_FUJI,
};

export const NETWORK_ID_SLUGS_MAP = invert(NETWORK_SLUGS_ID_MAP);
